export default {
	// Inhalt des Modals
	model: {
		id: 0,
		mode: 1,
		value: '',
		description: '',
		mode_name: '',
		is_main: false
	},

	name: 'contacts',

	// Die Spalten der Tabelle
	cols: [
		{
			'name': 'Haupt',
			'json': 'is_main',
			'type' (aValue) {
				return aValue === true ? [''] : []
				//return []
			},
			'hint': 'Zeigt an ob die Adresse die Hauptadresse ist.',
			'css': { 'default': '', true: 'btn btn-success btn-sm fa fa-check fa' },
			'colCSS': 'text-center'
		},
		{name: 'Art', json: 'mode_name', type: 'text'},
		{name: 'Nummer', json: 'value', type: 'text'},
		{name: 'Bemerkung', json: 'description', type: 'text', colCSS: 'hidden-xs'}
	],

	validate () {
		return true
	},

	validateModel () {
		return true
	},

	copy (aModel) {
		this.model.id = aModel.id
		this.model.mode = aModel.mode
		this.model.value = aModel.value
		this.model.description = aModel.description
		this.model.is_main = aModel.is_main

		return true
	},

	clear () {
		this.model.id = 0
		this.model.mode = 1
		this.model.value = ''
		this.model.description = ''
		this.model.is_main = false
	}
}



// WEBPACK FOOTER //
// ./src/models/contacts.js